import { IonContent } from '@ionic/react';
import React from 'react';
import { createUseStyles } from 'react-jss';
import { OrganizationsNavigationMenu } from '../organizations/OrganizationsNavigationMenu';
import { NewUINavigationList } from './NewUINavigationList';
import { IntercomNavItem } from '../support/intercom/IntercomNavItem';

const useStyles = createUseStyles<'content'>({
    content: {
        '--padding-top': '36px',

        '&::part(scroll)': {
            paddingTop: 0
        }
    },
});

export type INavigationContent = {
    closeMenuHandler: () => void;
};

export const NavigationContent: React.FC<INavigationContent> = ({ closeMenuHandler }) => {
    const classes = useStyles();

    const closeAndExecute = (handler: () => void) => {
        closeMenuHandler();
        setTimeout(() => {
            handler();
        }, 350);
    };

    return (
        <>
            <IonContent className={classes.content}>
                <OrganizationsNavigationMenu closeMenuHandler={closeMenuHandler} />

                <NewUINavigationList
                    closeMenuHandler={closeMenuHandler}
                />
                <IntercomNavItem clickHandler={closeAndExecute} />
            </IonContent>

        </>
    );
};
